import { apiCall } from 'src/utils/ApiCall';
import { GetControlPivotDataOutput } from '@amzn/controllershiphub-typescript-client';
import { CONTROL_APIS, ApiError } from 'src/common/config/ApiConstants';

interface PivotDataResponse {
  rowData: object[];
  pivotResultFields: string[];
  rowCount: number | undefined;
}

export const getControlPivotData = async (
  controlId: string,
  filters: Record<string, string[]> = {},
  aggregationValues: string[],
  rowAggregationField: string,
  columnAggregationFields: string[],
  groupKeys: string[]
): Promise<PivotDataResponse> => {
  try {
    // set up request params
    const body: Record<string, string | string[]> = {};
    if (Object.keys(filters).length > 0) {
      body.filters = JSON.stringify(filters);
      body.groupKeys = groupKeys;
    }

    // call API
    const response = await apiCall<GetControlPivotDataOutput>({
      endpoint: CONTROL_APIS.ENDPOINTS.PIVOT_DATA(controlId),
      method: 'POST',
      body: body,
    });

    return {
      rowData:
        response.rowData?.map((row) => {
          return JSON.parse(row);
        }) ?? [],
      pivotResultFields: response.pivotResultFields ?? [],
      rowCount: response.rowCount,
    };
  } catch (err: unknown) {
    const error = err as Error;
    if (error instanceof ApiError && error.status === 401) {
      throw new Error(CONTROL_APIS.ERROR_MESSAGES.UNAUTHORIZED);
    }
    throw new Error(CONTROL_APIS.ERROR_MESSAGES.DATA_FETCH_FAILED);
  }
};
